function PageLoading() {
  return (
    <>
      <h1>Loading ...</h1>
    </>
  );
}

export default PageLoading;
